import { clsx } from 'clsx';
import { Box } from '../../Box';
import { Link } from '../../Link';
import type { TypographyColors, TypographyVariants } from '../../Typography';
import { Typography } from '../../Typography';
import type { EmptyStateProps } from '../types';

interface EmptyStateDescriptionProps {
  description: EmptyStateProps['description'];
  color?: TypographyColors;
  variant?: TypographyVariants;
  className?: string;
  learnMore?: EmptyStateProps['learnMore'];
}

function EmptyStateDescription(props: EmptyStateDescriptionProps) {
  const { description, color, learnMore, className, variant } = props;

  return (
    <Box className="items-center">
      <Typography
        className={clsx(className, { 'me-xs !inline': learnMore })}
        color={color || 'text-tertiary'}
        maxNumberOfLines={3}
        variant={variant || 'text-sm'}
        weight="regular"
      >
        {description}
      </Typography>
      {learnMore ? (
        <Link
          className="font-semibold"
          color="brand"
          href={learnMore.href}
          size="sm"
          target="_blank"
        >
          {learnMore.label}
        </Link>
      ) : null}
    </Box>
  );
}

export default EmptyStateDescription;
